import { GenericResponse } from 'services/api/base';
import {
  MensalVisaoGeral,
  MensalChuva,
  MensalSimilaridadeClimatica,
  MensalCarga,
  MensalResultados,
  MensalPremissas,
} from 'types/Relatorios/Mensal';

export const transformMensalVisaoGeralResponse = (
  response: GenericResponse<MensalVisaoGeral>,
): MensalVisaoGeral => response.data;

export const transformMensalChuvaResponse = (
  response: GenericResponse<MensalChuva>,
): MensalChuva => response.data;

export const transformMensalSimilaridadeClimaticaResponse = (
  response: GenericResponse<MensalSimilaridadeClimatica>,
): MensalSimilaridadeClimatica => response.data;

export const transformMensalCargaResponse = (
  response: GenericResponse<MensalCarga>,
): MensalCarga => response.data;

export const transformMensalResultadosResponse = (
  response: GenericResponse<MensalResultados>,
): MensalResultados => response.data;

export const transformMensalPremissasResponse = (
  response: GenericResponse<MensalPremissas>,
): MensalPremissas => response.data;
